import { Link } from "react-router";
import { MYBT_ESHOP_SUBSCRIBE_CTA } from "@util/constant";

export default function KeywordLimitModalVersion1RegContent(): React.ReactElement {
  return (
    <div className="px-3 md:pb-3">
      <h2 className="my-3 text-center text-3xl font-semibold">
        Enjoying myBT so far?
      </h2>

      <p className="px-2 text-center text-gray-850 text-opacity-80">
        Now that you have experienced myBT with just a few keywords, subscribe
        to BT Premium to get full-access.
      </p>

      <Link
        to={MYBT_ESHOP_SUBSCRIBE_CTA}
        className="mx-auto block w-[45%] items-center rounded-full border-orange-300 bg-orange-300 px-4 py-2 text-center text-base font-bold !text-white md:w-7/20"
      >
        SUBSCRIBE NOW
      </Link>
    </div>
  );
}
